import React, { useState } from "react";
import { makeStyles } from "@material-ui/styles";
import {
  TextField,
  Grid,
  CardHeader,
  Typography,
  Button,
  Divider,
} from "@material-ui/core";
import PhotoCamera from "@material-ui/icons/PhotoCamera";
import SaveIcon from "@material-ui/icons/Save";
import RTL from "../../../../components/RTL";

const useStyles = makeStyles((theme) => ({
  imageContainer: {
    width: 140,
    height: 140,
    margin: "auto",
    position: "relative",
    overflow: "unset",
  },
  imageButton: {
    position: "absolute",
    left: -15,
    bottom: -10,
  },
  divider: {
    opacity: "0.1",
    marginLeft: "25%",
    marginRight: "25%",
    width: "50%",
    alignItems: "center",
    backgroundColor: "#273c75",
    height: 1,
  },
  image: {
    width: 110,
    height: 110,
  },
  input: {
    marginTop: theme.spacing(2),
  },
  imageInput: {
    display: "none",
  },
  submitButtonIcon: {
    marginLeft: theme.spacing(2),
  },
}));

const Form = (props) => {
  const { data, id, edit } = props;

  const classes = useStyles();

  return (
    <RTL>
      {!edit ? (
        <div >
          <CardHeader style={{textAlign:'center'}} title="ثبت نوع بار جدید" />
          <Divider className={classes.divider} variant="fullWidth" />
        </div>
      ) : (
        <div >
        <CardHeader style={{textAlign:'center'}} title="ویرایش نوع بار" />
        <Divider className={classes.divider} variant="fullWidth" />
      </div>
      )}

      {!edit ? (
        <TextField
          className={classes.input}
          label="نوع بار"
          placeholder="به عنوان مثال کاشی"
          variant="outlined"
        />
      ) : (
        <Grid alignItems="flex-start" item xs={12} sm={12}>
          <TextField
            className={classes.input}
            label="نوع بار"
            placeholder="به عنوان مثال کاشی"
            variant="outlined" 
            defaultValue={
                edit
                  ? // alert(data.id)
                    data
                      .filter((data) => data.id == id)
                      .map((filterData) => filterData.typeContract)
                  : ""
              }
          />
        </Grid>
      )}


{!edit ? (
         <Button
         className={classes.input}
         variant="contained"
         color="secondary"
         size="large"
         startIcon={<SaveIcon className={classes.submitButtonIcon} />}
       >
         ذخــــیــره
       </Button>
      ) : (
        <Grid  alignItems="flex-start" item xs={12} sm={12}>
           <Button
        className={classes.input}
        variant="contained"
        style={{width:'100%'}}
        color="secondary"
        size="large"
        startIcon={<SaveIcon className={classes.submitButtonIcon} />}
      >
        بروزرسانی
      </Button>
        </Grid>
      )}

     
    </RTL>
  );
};

export default Form;
